import type React from 'react';
import SvgMaskIcon from './SvgMaskIcon';

interface ArrowUpIconProps {
    width?: number;
    height?: number;
    /** Color of the arrow icon itself */
    color?: string;
    /** Background circle color - defaults to transparent for backward compatibility */
    backgroundColor?: string;
    className?: string;
    style?: React.CSSProperties;
}

const INNER =
    '<path d="M17.7102 11.29L12.7102 6.29C12.6151 6.19896 12.5029 6.1276 12.3802 6.08C12.1367 5.97999 11.8636 5.97999 11.6202 6.08C11.4974 6.1276 11.3853 6.19896 11.2902 6.29L6.29019 11.29C6.19695 11.3832 6.12299 11.4939 6.07253 11.6158C6.02207 11.7376 5.99609 11.8681 5.99609 12C5.99609 12.2663 6.10188 12.5217 6.29019 12.71C6.47849 12.8983 6.73388 13.0041 7.00019 13.0041C7.26649 13.0041 7.52188 12.8983 7.71019 12.71L11.0002 9.41V17C11.0002 17.2652 11.1055 17.5196 11.2931 17.7071C11.4806 17.8946 11.735 18 12.0002 18C12.2654 18 12.5198 17.8946 12.7073 17.7071C12.8948 17.5196 13.0002 17.2652 13.0002 17V9.41L16.2902 12.71C16.3831 12.8037 16.4937 12.8781 16.6156 12.9289C16.7375 12.9797 16.8682 13.0058 17.0002 13.0058C17.1322 13.0058 17.2629 12.9797 17.3848 12.9289C17.5066 12.8781 17.6172 12.8037 17.7102 12.71C17.8039 12.617 17.8783 12.5064 17.9291 12.3846C17.9798 12.2627 18.006 12.132 18.006 12C18.006 11.868 17.9798 11.7373 17.9291 11.6154C17.8783 11.4936 17.8039 11.383 17.7102 11.29Z" fill="#000"/>';

const ArrowUpIcon: React.FC<ArrowUpIconProps> = ({
    width = 24,
    height = 24,
    color = 'currentColor',
    backgroundColor,
    className = '',
    style = {},
}) => {
    // No background circle: render the masked arrow directly.
    if (!backgroundColor) {
        return (
            <SvgMaskIcon
                viewBox="0 0 24 24"
                inner={INNER}
                width={width}
                height={height}
                color={color}
                className={className}
                style={{ pointerEvents: 'none', ...style }}
            />
        );
    }

    // Two-color mode: a colored circle behind the arrow. Nested spans keep it out of the
    // inline-SVG commit path that host appendChild monkeypatches break (IX-4048 / IX-4076).
    return (
        <span
            aria-hidden="true"
            className={className}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width,
                height,
                borderRadius: '50%',
                backgroundColor,
                pointerEvents: 'none',
                ...style,
            }}
        >
            <SvgMaskIcon
                viewBox="0 0 24 24"
                inner={INNER}
                width={width}
                height={height}
                color={color}
            />
        </span>
    );
};

export default ArrowUpIcon;
